var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDscSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9473 0.343739L6.29611 5.14691C6.26266 5.18134 6.21484 5.20989 6.15741 5.22972C6.09997 5.24956 6.03491 5.26 5.96871 5.26C5.9025 5.26 5.83744 5.24956 5.78 5.22972C5.72257 5.20989 5.67475 5.18134 5.6413 5.14691L0.990096 0.343739C0.956387 0.308939 0.938547 0.269389 0.938387 0.229097C0.938226 0.188806 0.95575 0.149204 0.989182 0.114307C1.02261 0.0794102 1.07076 0.0504576 1.12876 0.0303839C1.18675 0.0103102 1.25252 -0.00017121 1.3194 2.11525e-06L10.6195 2.11525e-06C10.6863 -9.80309e-06 10.7519 0.0105892 10.8096 0.0307287C10.8674 0.0508682 10.9154 0.0798353 10.9486 0.114705C10.9819 0.149575 10.9992 0.189113 10.999 0.229327C10.9988 0.26954 10.981 0.309006 10.9473 0.343739Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDscSort);
export default __webpack_public_path__ + "static/media/dsc-sort.fad0d6a5409e18a6f107f8696656b199.svg";
export { ForwardRef as ReactComponent };